import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';

export const employeeBondApi = createApi({
  reducerPath: 'employeeBondApi',
  baseQuery: baseQueryV1,
  tagTypes: ['EmployeeBonds', 'RenewalBoard', 'RenewalSummary'],
  endpoints: (builder) => ({
    getBondsByUserId: builder.query({
      query: (userId) => ({
        url: `employee-bonds/user/${userId}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['EmployeeBonds'],
    }),
    addBond: builder.mutation({
      query: (bond) => ({
        url: 'employee-bonds',
        method: 'POST',
        body: bond,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeeBonds'],
    }),
    updateBond: builder.mutation({
      query: ({ id, ...bond }) => ({
        url: `employee-bonds/${id}`,
        method: 'PUT',
        body: bond,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeeBonds', 'RenewalBoard', 'RenewalSummary'],
    }),
    deleteBond: builder.mutation({
      query: (id) => ({
        url: `employee-bonds/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['EmployeeBonds'],
    }),
    getUpcomingBondExpirations: builder.query({
      query: (days = 30) => ({
        url: `employee-bonds/upcoming?days=${days}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['EmployeeBonds'],
    }),
    // ── Renewal Board ──────────────────────────────────────────────────────────
    getRenewalBoard: builder.query({
      query: () => ({
        url: 'employee-bonds/renewal-board',
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['RenewalBoard'],
    }),
    getRenewalSummary: builder.query({
      query: () => ({
        url: 'employee-bonds/renewal-summary',
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['RenewalSummary'],
    }),
    updateBondWorkflow: builder.mutation({
      query: ({ id, workflow_status }) => ({
        url: `employee-bonds/${id}/workflow`,
        method: 'PATCH',
        body: { workflow_status },
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['RenewalBoard', 'RenewalSummary'],
    }),
    renewBond: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `employee-bonds/${id}/renew`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['RenewalBoard', 'RenewalSummary', 'EmployeeBonds'],
    }),
  }),
});

export const {
  useGetBondsByUserIdQuery,
  useAddBondMutation,
  useUpdateBondMutation,
  useDeleteBondMutation,
  useGetUpcomingBondExpirationsQuery,
  useGetRenewalBoardQuery,
  useGetRenewalSummaryQuery,
  useUpdateBondWorkflowMutation,
  useRenewBondMutation,
} = employeeBondApi;
